import { render } from "./ApprovalDialog.vue?vue&type=template&id=283ad13e&scoped=true"
import script from "./ApprovalDialog.vue?vue&type=script&lang=js"
export * from "./ApprovalDialog.vue?vue&type=script&lang=js"

import "./ApprovalDialog.vue?vue&type=style&index=0&id=283ad13e&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283ad13e"]])

export default __exports__